import { render, staticRenderFns } from "./address-block.vue?vue&type=template&id=c19a2734&"
import script from "./address-block.vue?vue&type=script&lang=js&"
export * from "./address-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports